const topicItems = [
  { name: '#某顶流恋情', heat: '986万', trend: 'up', rank: 1 },
  { name: '#综艺名场面', heat: '752万', trend: 'up', rank: 2 },
  { name: '#网红互撕', heat: '648万', trend: 'hot', rank: 3 },
  { name: '#暑期档口碑', heat: '521万', trend: 'up', rank: 4 },
  { name: '#明星翻车', heat: '489万', trend: 'down', rank: 5 },
  { name: '#音乐榜揭晓', heat: '367万', trend: 'up', rank: 6 },
  { name: '#代言人变更', heat: '298万', trend: 'new', rank: 7 },
  { name: '#电影节红毯', heat: '245万', trend: 'down', rank: 8 },
  { name: '#经典IP翻拍', heat: '189万', trend: 'new', rank: 9 },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-2">
          热门话题追踪
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">全网热议话题实时热度排行，吃瓜先看这里</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {topicItems.map((topic, i) => (
            <div
              key={i}
              className="flex items-center gap-4 bg-background-100 rounded-lg border border-background-200/70 p-4 hover:border-primary-200/50 transition-all cursor-pointer"
            >
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                topic.rank === 1 ? 'bg-primary-500 text-background-50' :
                topic.rank === 2 ? 'bg-accent-500 text-background-50' :
                topic.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {topic.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 truncate">{topic.name}</h3>
                <p className="text-xs text-foreground-400 mt-0.5">{topic.heat}热度</p>
              </div>
              <span className={`flex-shrink-0 text-xs font-medium ${
                topic.trend === 'up' ? 'text-primary-600' :
                topic.trend === 'hot' ? 'text-accent-600' :
                topic.trend === 'new' ? 'text-secondary-600' :
                'text-foreground-400'
              }`}>
                {topic.trend === 'up' ? '↑ 上升' :
                 topic.trend === 'hot' ? '🔥 爆' :
                 topic.trend === 'new' ? '新' :
                 '↓ 下降'}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}